import { Component, OnInit, ViewChild } from "@angular/core";
import { GraphQLClient } from "../../shared/services/graph-qlclient.service";
import gql from "graphql-tag";
import { Observable } from "apollo-client/util/Observable";
import { Observer, Subject } from "rxjs";
import { zona } from "../../shared/object/zona.model";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { SecurityService } from "../../shared/services/security.service";
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: "app-zona",
  templateUrl: "./zona.component.html",
  styleUrls: ["./zona.component.scss"],
  providers: [SecurityService, ValidadoresService],
})
export class ZonaComponent implements OnInit {
  private client: GraphQLClient = null;
  zonaList: zona[];
  selectedZona: zona;
  zona: zona;
  public formAgregarZona: FormGroup;
  public formEditarZona: FormGroup;

  public rut_empresa;
  public sucursal_codigo;
  public busquedaEstado;

  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 7;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
  ) {
    this.client = client;
    this.formAgregarZona = this.construyeFormAgrega();
    this.formEditarZona = this.construyeFormEdita();
    this.busquedaEstado = 1;
  }

  construyeFormAgrega() {
    return new FormGroup({
      nombre: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      descripcion: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      estado: new FormControl(true),
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl(""),
      rut_empresa: new FormControl(""),
      sucursal_codigo: new FormControl(""),
      nombre: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      descripcion: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      estado: new FormControl(true),
    });
  }

  muestraModalAgrega() {
    this.selectedZona = {
      rut_empresa: null,
      sucursal_codigo: null,
      codigo: null,
      nombre: "",
      descripcion: "",
      estado: null,
    };
    this.formAgregarZona.reset();
  }
  filtraxEstado()
  {
    this.obtenerDatosZona(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo));
  }


  ngOnInit() {
    this.selectedZona = {
      codigo: null,
      rut_empresa: null,
      sucursal_codigo: null,
      descripcion: "",
      nombre: "",
      estado: null,
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosZona(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo)
    );
  }

  get frmAgregaNombre() {
    return this.formAgregarZona.get("nombre");
  }
  get frmAgregaDescripcion() {
    return this.formAgregarZona.get("descripcion");
  }
  get frmAgregaEstado() {
    return this.formAgregarZona.get("estado");
  }

  get frmEditarCodigo() {
    return this.formEditarZona.get("codigo");
  }
  get frmEditarRut_Empresa() {
    return this.formEditarZona.get("rut_empresa");
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarZona.get("sucursal_codigo");
  }
  get frmEditarNombre() {
    return this.formEditarZona.get("nombre");
  }
  get frmEditarDescripcion() {
    return this.formEditarZona.get("descripcion");
  }
  get frmEditarEstado() {
    return this.formEditarZona.get("estado");
  }

  obtenerDatosZona(rut_empresa: number, sucursal_codigo: number) {
    //console.log("obtenerDatosnew")
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda:Int) {
            zona {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                  }
                }
              ) {
                respuesta {
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    descripcion
                    estado
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'network-only',
        variables: {
          "rut_empresa": rut_empresa,
          "sucursal_codigo": sucursal_codigo,
          "tipobusqueda": this.busquedaEstado
        },
      },
      function (respuesta) {
        self.zonaList =
          respuesta.data.zona.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  cambiaEstado(zonaSeleccionada: zona) {

    if (zonaSeleccionada.estado) {
      zonaSeleccionada.estado = false;
    } else {
      zonaSeleccionada.estado = true;
    }
    this.refrescar(zonaSeleccionada);
  }

  showForEdit(zon: zona) {
    //console.log(vend);

    this.formEditarZona.reset();
    this.selectedZona = Object.assign({}, zon);

    this.frmEditarNombre.setValue(zon.nombre);
    this.frmEditarDescripcion.setValue(zon.descripcion);
    this.frmEditarCodigo.setValue(zon.codigo);
    this.frmEditarRut_Empresa.setValue(zon.rut_empresa);
    this.frmEditarSucursal_Codigo.setValue(zon.sucursal_codigo);
    this.frmEditarEstado.setValue(zon.estado);
  }

  insertar() {
    this.selectedZona.nombre = this.frmAgregaNombre.value;
    this.selectedZona.descripcion = this.frmAgregaDescripcion.value;

    this.selectedZona.codigo = 0;
    this.selectedZona.rut_empresa = Number(this.rut_empresa);
    this.selectedZona.sucursal_codigo = Number(this.sucursal_codigo);
    this.selectedZona.estado = this.frmAgregaEstado.value;

    this.postZona(this.selectedZona);
  }

  postZona(zona: zona) {
    let self = this;
    var bodyx = zona;
    //console.log(bodyx);
    //var self = this;
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: zonaInputType) {
            zona {
              agregar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerDatosZona(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  actualizar() {
    this.selectedZona.codigo = this.frmEditarCodigo.value;
    this.selectedZona.rut_empresa = this.frmEditarRut_Empresa.value;
    this.selectedZona.sucursal_codigo = this.frmEditarSucursal_Codigo.value;
    this.selectedZona.nombre = this.frmEditarNombre.value;
    this.selectedZona.descripcion = this.frmEditarDescripcion.value;
    this.selectedZona.estado = this.frmEditarEstado.value;

    this.refrescar(this.selectedZona);
  }

  refrescar(zona_sel: zona) {
    let self = this;
    delete zona_sel["__typename"];

    var bodyx = zona_sel;
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: zonaInputType) {
            zona {
              modificar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerDatosZona(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(zonaSeleccionada: zona) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(zonaSeleccionada);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
